import { Dispatch, ReactNode, SetStateAction } from 'react'

export type SidebarProviderProps = {
  children: ReactNode
}

export type SidebarContextProps = {
  isOpenSidebar: boolean
  sidebarContent: ReactNode
  titleSidebar: string
  setTitleSidebar: Dispatch<SetStateAction<string>>
  setSidebarContent: Dispatch<SetStateAction<ReactNode>>
  closeSidebar: () => void
  openSidebar: () => void
  sidebarMeta: SidebarMeta | null
  setSidebarMeta: Dispatch<SetStateAction<SidebarMeta | null>>
}

export enum SupportedSidebar {
  ONBOARDING,
  PIN_POST
}

export type SidebarMeta = {
  name: SupportedSidebar
}
